import UnitPrefsTable from './UnitPrefsTable';

const QueryUnitPrefs = ({ preferences, setPreference, deletePreference }) => (
  <UnitPrefsTable
    editable
    displayInactive={false}
    callbacks={{ setPreference, deletePreference }}
    preferences={preferences ?? []}
  />
);

export default QueryUnitPrefs;
